__turbopack_context__.v({
  "fixed": "UbDksG_fixed",
  "icon": "UbDksG_icon",
  "intrinsic": "UbDksG_intrinsic",
  "inverse": "UbDksG_inverse",
  "panel": "UbDksG_panel",
  "selected": "UbDksG_selected",
  "tab": "UbDksG_tab",
  "tablist": "UbDksG_tablist",
});
